import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LabelComponent } from '../label/label.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-site-tags',
  templateUrl: './site-tags.component.html',
  styleUrls: ['./site-tags.component.scss'],
  imports: [LabelComponent, NgSelectComponent, FormsModule, TranslatePipe],
})
export class SiteTagsComponent {
  @Input('tags') tags: string[];
  @Output() selectedChange = new EventEmitter<string[]>();
  @Input('selected') selected = [];

  constructor() {}
}
